import React, { Fragment, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import PropTypes from "prop-types";

const Formulario = ({ crearCita }) => {
	//crear cita

	const [cita, actualizarCita] = useState({
		cliente: "",
		apellido: "",
		fecha: "",
		hora: "",
		detalles: "",
	});

	const [error, actualizarError] = useState(false);

	// Función que se ejecuta cada que el usuario escribe en un input
	const actualizarState = (e) => {
		actualizarCita({
			...cita,
			[e.target.name]: e.target.value,
		});
	};

	//extrater valores
	const { cliente, apellido, fecha, hora, detalles } = cita;

	//cuando el usuario presiona agregar cita

	const submitCita = (e) => {
		e.preventDefault();

		//Validar
		if (
			cliente.trim() === "" ||
			apellido.trim() === "" ||
			fecha.trim() === "" ||
			hora.trim() === "" ||
			detalles.trim() === ""
		) {
			actualizarError(true);

			return;
		}

		//eliminar elmensaje previo
		actualizarError(false);

		//Asignar id
		cita.id = uuidv4();

		//Crear la cita
		crearCita(cita);

		//Reainiciar el form

		actualizarCita({
			cliente: "",
			apellido: "",
			fecha: "",
			hora: "",
			detalles: "",
		});
	};

	return (
		<Fragment>
			<h2>Crear Citas</h2>
			{error ? (
				<p className="alerta-error">Todos los campos son obligatorios</p>
			) : null}
			<form onSubmit={submitCita}>
				<label>Nombre del Cliente</label>
				<input
					type="text"
					name="cliente"
					className="u-full-width"
					placeholder="Nombre Cliente"
					onChange={actualizarState}
					value={cliente}
				/>
				<label>Apellido del cliente</label>
				<input
					type="text"
					name="apellido"
					className="u-full-width"
					placeholder="Apellido del Cliente"
					onChange={actualizarState}
					value={apellido}
				/>
				<label>Fecha</label>
				<input
					type="date"
					name="fecha"
					className="u-full-width"
					onChange={actualizarState}
					value={fecha}
				/>
				<label>Hora</label>
				<input
					type="time"
					name="hora"
					className="u-full-width"
					onChange={actualizarState}
					value={hora}
				/>
				<label>Detalles</label>
				<textarea
					className="u-full-width"
					name="detalles"
					onChange={actualizarState}
					value={detalles}
				></textarea>
				<button type="submit" className="u-full-width button-primary">
					Agregar Cita
				</button>
			</form>
		</Fragment>
	);
};

Formulario.propTypes = {
	crearCita: PropTypes.func.isRequired,
	//eliminarCita:PropTypes.func.isRequired
};

export default Formulario;
